<template>
  <div
    class="hero-pattern flex flex-wrap md:flex-nowrap items-center justify-between md:gap-2 rounded-lg from-60% from-[#31383D] to-[#687580] p-3 pb-4 text-white"
    style="background-image: linear-gradient(45deg, var(--tw-gradient-stops))"
  >
    <div class="min-w-[80px] md:min-w-[100px] order-1 pl-1">
      <p class="text-2xl font-bold leading-none -mt-3 md:mt-0">{{ level.numb }}</p>
      <p class="leading-none">{{ level.name }}</p>
    </div>
    <div
      class="flex flex-col flex-grow gap-2 order-3 md:order-2 w-full md:w-auto pl-1 -mt-2 md:mt-0"
    >
      <div class="flex gap-1">
        <div class="text-xs rounded-md px-2 py-0.5 bg-blue-500">{{levelStats.total}} vistas</div>
        <div class="text-xs rounded-md px-2 py-0.5 bg-emerald-500">
          {{levelStats.correctas}} Correctas
        </div>
      </div>
      <div class="h-1.5 bg-neutral-300 rounded-full overflow-hidden">
        <div class="h-full bg-blue-500" :style="{ width: getPercetage + '%' }"></div>
      </div>
    </div>
    <div class="order-2 md:order-3">
      <img :src="level.img" class="w-[72px] h-[72px]"  alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LevelStats",
  props:{
    levelStats: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    getPercetage() {
      const total = this.levelStats.total || 0;
      if (!total) return 0;
      return Math.round(((this.levelStats.correctas || 0) / total) * 100);
    },
    level() {
      const puntuacion = this.levelStats.puntuacion;
      let level = { numb: "Nivel 1", name: "Esfera", img: "/images/levels/level-1.png"};
      // let 
      switch (true) {
        case (puntuacion >= 0 && puntuacion < 199):
        level = { numb: "Nivel 1", name: "Esfera", img: "/images/levels/level-1.png" };
          break;
        case (puntuacion >= 200 && puntuacion < 399):
        level = { numb: "Nivel 2", name: "Cono", img: "/images/levels/level-2.png" };
          break;
        case (puntuacion >= 400 && puntuacion < 699):
        level = { numb: "Nivel 3", name: "Tetraedo", img: "/images/levels/level-3.png" };
          break;
        case (puntuacion >= 700 && puntuacion < 999):
        level = { numb: "Nivel 4", name: "Cubo", img: "/images/levels/level-4.png" };
          break;
        case (puntuacion >= 1000 && puntuacion < 1499):
        level = { numb: "Nivel 5", name: "Octaedro", img: "/images/levels/level-5.png" };
          break;
        case (puntuacion >= 1500 && puntuacion < 1999):
        level = { numb: "Nivel 6", name: "Dodecaedro", img: "/images/levels/level-6.png" };
          break;
        case (puntuacion >= 2000):
        level = { numb: "Nivel 7", name: "Icosaedro", img: "/images/levels/level-7.png" };
          break;
      }
      return level;
    }
  },
  mounted() {

    // console.log("Level Stats on mounted:", this.levelStats.puntuacion);
  }
};
</script>
